module.exports = __webpack_public_path__ + "img/ico-adubo.c11d4c26.png";